module.exports = __webpack_public_path__ + "osaka-hotel.jpg?09529da88d331bc37d214e5d7f53ff48";


//////////////////
// WEBPACK FOOTER
// ./src/assets/osaka-hotel.jpg
// module id = 94
// module chunks = 0